import { render, staticRenderFns } from "./WUserAccountRecoveryOne.vue?vue&type=template&id=5c0a3133&"
import script from "./WUserAccountRecoveryOne.vue?vue&type=script&lang=ts&"
export * from "./WUserAccountRecoveryOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports